export default __webpack_public_path__ + "static/media/sidebar-bg.671f8854.svg";